<template>
  <!-- 首页 -->
  <div class="ourProducts_component">
      <ul class="menu_top">
          <li v-for="(item,index) in menuList" :key="index" ref="menuItem" @click="clickMenuList(index,'menuItem'+index)">
              <div class="imgWarp">
                  <img :src="item.img" v-show="needindex==index?false:true">
                  <img :src="item.img2" v-show="needindex==index?true:false">
              </div>
              <p class="abc" :style="{color:needindex==index?'#50AEFE':''}">{{item.title}}</p>
          </li>
      </ul>
      <div v-if="menuList.length > 0" class="hengGang"><p :style="{left:p_offsetLeft+'px'}"></p></div>
      <div v-if="contentList.length > 0" class="mainWarp" >
          <ul :style="{width:contentList.length*1200+'px',left:needindex*-1200+'px'}">
              <li class="mainUlLi" v-for="(item,index) in contentList" :key="index">
                  <div class="mainLeft"><img v-lazy="item.img"></div>
                  <div class="mainRight">
                      <div class="main_title" v-html="item.title"></div>
                      <div class="main_content" v-html="item.content"></div>
                      <ol>
                          <li v-for="(itemSub,indexSub) in item.subChild" :key="indexSub">
                              <p>{{itemSub.title}}</p>
                              <p>{{itemSub.content}}</p>
                          </li>
                      </ol>
                  </div>
              </li>
          </ul>
      </div>
  </div>
</template>

<script>
  export default {
    name: 'ourProducts_component',
    props: {
      menuList: {
        type: Array,
        default: () => {
          return []
        }
      },
      contentList: {
        type: Array,
        default: () => {
          return []
        }
      }
    },
    data () {
      return {
          p_offsetLeft:0,
          needindex:0,
      }
    },
    methods:{
        clickMenuList(index,refsItem){
            this.needindex = index;
            this.p_offsetLeft = this.$refs.menuItem[index].offsetLeft + 15
        }
    },
    mounted(){
        this.p_offsetLeft = this.$refs.menuItem[0].offsetLeft + 15
    }
  }
</script>

<style scoped lang="less">
.ourProducts_component{
    padding:20px 0 60px 0;
    .menu_top{
        display: flex;
        flex-direction: row;
        justify-content: space-around;
        align-items: center;
        box-sizing: border-box;
        padding: 0 180px;
        position: relative;
        li{
            width: 80px;
            text-align: center;
            cursor: pointer;
            // margin-right: 100px;
            display: flex;
            flex-direction: column;
            justify-content: flex-start;
            align-items: center;
            .imgWarp{
                width: 80px;
                height: 100px;
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                img{
                    // max-width: 100%;
                    // max-height: 100%;
                    height: 100px;
                    width: auto;
                }
            }
            p{
                font-size: 14px;
                color:#42476C;
                padding:10px 0 0 0;
                font-weight:500;
                white-space: nowrap;
            }
        }
        li:last-child{
            margin-right: 0;
        }
        li:hover p {
            color: rgb(80, 174, 254);
        }
    }
    .hengGang{
        width: 100%;
        position: relative;
        padding: 6px;
        p{
            width:50px;
            height:3px;
            transition: 0.3s;
            position: absolute;
            top:6px;
            background:rgba(80,174,254,1);
        }
    }
    .mainWarp{
        width: 100%;
        margin: auto;
        position: relative;
        height: 290px;
        padding-bottom: 20px;
        overflow: hidden;
        ul{
            position: absolute;
            left:0;
            top:50px;
            transition: 0.6s;
            clear:both;
            display: flex;
            // height: 240px;
            .mainUlLi{
                width: 100%;
                display: flex;
                // float: left;
                justify-content: center;
                .mainLeft{
                    width:240px;
                    height:240px;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    background:rgba(255,255,255,1);
                    margin-right: 40px;
                    box-shadow:0px 6px 12px 0px rgba(0,0,0,0.2);
                    border-radius:24px;
                    img{
                        height: 134px;
                    }
                }
                .mainRight{
                    .main_title{
                        font-size: 36px;
                        padding: 16px 0 0 0;
                        color:#42476C;
                        font-weight:600;
                    }
                    .main_content{
                        color:#42476C;
                        padding-top:15px;
                        font-weight:400;
                    }
                    ol{
                        display: flex;
                        padding: 40px 0 0 0;
                        li{
                            padding-right:78px;
                            p:nth-child(1){
                                font-size: 14px;
                                color:#42476C;
                            }
                            p:nth-child(2){
                                font-size: 36px;
                                color:#152F6A;
                                font-weight:600;
                            }
                        }
                        li:last-child{
                            padding-right:0px;
                        }
                    }
                }
            }
        }
    }
}

.imgWarp:hover img:first-child {
    display: none !important;
}

.imgWarp:hover img:last-child {
    display: inline !important;
}

</style>



// WEBPACK FOOTER //
// src/page/home/homeComponents/ourProducts.vue